/** Matches the auto-generated names this helper produces, e.g. "Campaign (12)". */
const AUTO_NAME_PATTERN = /^campaign\s*\((\d+)\)$/i;

/**
 * Suggests the campaign name the create modal is prefilled with (PREC-3860), so a
 * user who has nothing particular in mind can save straight away instead of being
 * blocked by the required name field.
 *
 * Numbering fills the lowest free slot among the names already on the list that
 * look auto-generated — an empty list yields "Campaign (1)", and a list holding
 * "Campaign (1)" + "Campaign (3)" yields "Campaign (2)". Names the user typed
 * themselves are ignored, and nothing here enforces uniqueness: the suggestion
 * only avoids an obvious visual collision.
 */
export const nextDefaultCampaignName = (
	campaignConfig?: Record<string, { name?: string | null } | null | undefined> | null
): string => {
	const usedNumbers = new Set<number>();

	for (const campaign of Object.values(campaignConfig ?? {})) {
		const match = campaign?.name?.trim().match(AUTO_NAME_PATTERN);

		if (match) {
			usedNumbers.add(Number(match[1]));
		}
	}

	let next = 1;

	while (usedNumbers.has(next)) {
		next += 1;
	}

	return `Campaign (${next})`;
};
